if (!customElements.get('pocket-square-upsell')) {
  customElements.define(
    'pocket-square-upsell',
    class PocketSquareUpsell extends HTMLElement {
      connectedCallback() {
        this.addEventListener('click', (event) => {
          const button = event.target.closest('.ps-upsell__add');
          if (!button || button.getAttribute('aria-busy') === 'true') return;
          this.add(button);
        });
      }

      add(button) {
        const cartDrawer = document.querySelector('cart-drawer');
        const error = this.querySelector('.ps-upsell__error');
        button.setAttribute('aria-busy', 'true');
        button.textContent = 'Adding…';
        error.hidden = true;

        fetch(`${routes.cart_add_url}`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/javascript' },
          body: JSON.stringify({
            items: [{ id: Number(button.dataset.variantId), quantity: 1 }],
            sections: cartDrawer.getSectionsToRender().map((section) => section.id),
            sections_url: window.location.pathname,
          }),
        })
          .then((response) => response.json())
          .then((state) => {
            if (state.status) {
              error.textContent = state.description || state.message;
              error.hidden = false;
              button.textContent = '+ Add';
              button.removeAttribute('aria-busy');
              return;
            }
            if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
              publish(PUB_SUB_EVENTS.cartUpdate, { source: 'pocket-square-upsell', cartData: state });
            }
            cartDrawer.renderContents(state);
          })
          .catch(() => {
            error.textContent = window.cartStrings ? window.cartStrings.error : 'Something went wrong. Try again.';
            error.hidden = false;
            button.textContent = '+ Add';
            button.removeAttribute('aria-busy');
          });
      }
    }
  );
}
